<div class="photo-list-container-bulk-delete" *ngIf="path">
    <label>{{this.options?.label || 'Selected Photos'}}</label>
	<div class="photo-list">
		<div class="row">
			<ng-container *ngFor="let image of album; let i= index">
				<div class="selected-item {{options?.galleryItemCss || ''}}">
					<span class="icon" (click)="selectPhoto(i)">
						<i [ngClass]="{
							'fas': true,
							'fa-square': selectedPhotos.indexOf(image.id) === -1,
							'fa-check-square': selectedPhotos.indexOf(image.id) > -1
							}"></i>
					</span>
					<img [src]="image.thumb" class="img-fluid" (click)="openGallery(i)">
				</div>
			</ng-container>
		</div>
	</div>

	<div class="row">
		<div class="col-3 ms-auto text-end">
			<button class="btn btn-danger"
				[disabled]="selectedPhotos.length < 1"
				(click)="deletePhotos()">
				<i class="fas fa-trash-alt"></i>
				Delete
			</button>
		</div>
	</div>

</div>
